import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minCharacters(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value.trim().length >= min ? null : { minCharacters: { value: control.value } };
  };
}
